// extracted by mini-css-extract-plugin
module.exports = {"tagLine":"SiteDetailsSection_tagLine__NpJSD","strapLine":"SiteDetailsSection_strapLine__1Dric","details":"SiteDetailsSection_details__3vfXj"};